import React from 'react';
// import '../styles/KeyFeatures.css';
import document from '../../../../assets/icons/document.svg';
import security from '../../../../assets/icons/security.svg';
import users from '../../../../assets/icons/users.svg';
import ai from '../../../../assets/icons/ai.svg';
import organization from '../../../../assets/icons/organization.svg';
import integration from '../../../../assets/icons/integration.svg';


const features = [
  {
    icon: <img src={document} alt="Document Requests" className="kf-icon" />, // purple bg
    title: 'DOCUMENT REQUESTS',
    desc: 'Create and send document requests with customizable templates',
    iconBg: 'kf-bg-purple',
  },
  {
    icon: <img src={security} alt="Secure Storage" className="kf-icon" />, // pink bg
    title: 'SECURE STORAGE',
    desc: 'End-to-end encryption and compliance with industry standards',
    iconBg: 'kf-bg-pink',
  },
  {
    icon: <img src={users} alt="Team Collaboration" className="kf-icon" />, // blue bg
    title: 'TEAM COLLABORATION',
    desc: 'Share documents securely with team members and clients',
    iconBg: 'kf-bg-blue',
  },
  {
    icon: <img src={ai} alt="AI-Powered Insights" className="kf-icon" />, // green bg
    title: 'AI-POWERED INSIGHTS',
    desc: 'Extract key information and generate summaries automatically',
    iconBg: 'kf-bg-green',
  },
  {
    icon: <img src={organization} alt="Advanced Organization" className="kf-icon" />, // orange bg
    title: 'ADVANCED ORGANIZATION',
    desc: 'Organize with tags, folders, and smart search functionality',
    iconBg: 'kf-bg-orange',
  },
  {
    icon: <img src={integration} alt="Integrations" className="kf-icon" />, // purple bg
    title: 'INTEGRATIONS',
    desc: 'Connect with your favorite tools and platforms seamlessly',
    iconBg: 'kf-bg-purple',
  },
];

const KeyFeatures = () => {
  return (
    <section className="key-features">
      <div className="container">
        <div className="key-features-header">
          <h2 className="key-features-header-title">
            KEY FEATURES
          </h2>
          <p className="key-features-header-subtitle">
            Discover how DocuSafe.ai transforms document management
          </p>
        </div>
        <div className="key-features-grid">
          {features.map((feature, index) => (
            <div className="key-feature-card" key={index}>
              <div className={`icon-wrapper ${feature.iconBg}`}>{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default KeyFeatures; 